<hazmatsuite-next-stepper
  [async]="false"
  [steps]="(stepperItems$ | async) || []"
  (selectStep)="selectStep($event)"
></hazmatsuite-next-stepper>

<ng-container *ngIf="downloadResource$ | async as downloadResource">
  <ng-container *ngIf="commonResource$ | async as commonResource">
    <ng-container *ngIf="paymentResource$ | async as paymentResource">
      <ng-container *ngIf="validationResource$ | async as validationResource">
        <div id="ch-ggs-web-suite-content" *ngIf="model">
          <div class="container">
            <h1>{{ downloadResource['HeadingTitle'] }}</h1>

            <div class="row">
              <div class="col-md-6">
                <a
                  [href]="downloadUrl"
                  target="_blank"
                  *ngIf="model.Base64Image"
                >
                  <img
                    [src]="model.Base64Image"
                    class="shipping-paper-preview-image"
                  />
                </a>
                <div class="mt-5">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left w-auto"
                    (click)="restartModule()"
                  >
                    {{ commonResource['BackButton'] }}
                    <i class="btn-icon ifc-custom ifc-arrow-left"></i
                  ></a>
                </div>
              </div>

              <div class="offset-3 col-3 mt-5 mt-md-0">
                <div class="ch-ggs-web-suite-aside-box">
                  <div class="ch-ggs-web-suite-boxed-gray">
                    <h3>{{ downloadResource['Success'] }}</h3>
                    <p>{{ downloadResource['SuccessInfo'] }}</p>
                    <p>
                      {{ downloadResource['HeadingTitle'] }}
                      {{ paymentResource['YourBookingReference'] }}
                      <strong>{{ model.BookingReference }}</strong>
                    </p>
                    <p>
                      <span
                        *ngIf="model.PaymentType === paymentTypes.Credits"
                        >{{ downloadResource['NewCreditsAmount'] }}</span
                      >
                      <span
                        *ngIf="model.PaymentType !== paymentTypes.Credits"
                        >{{ paymentResource['YourCredits'] }}</span
                      >&nbsp;
                      <strong>{{ model.CreditsCount }}</strong>
                    </p>

                    <a
                      class="no-spinner btn btn-block btn-iconed btn-iconed-primary"
                      [href]="downloadUrl"
                      target="_blank"
                    >
                      {{ downloadResource['ClickHereToDownload'] }}
                      <i
                        class="btn-icon ifc-custom ifc-vertical_align_bottom"
                      ></i>
                    </a>

                    <button
                      class="btn btn-block btn-iconed btn-iconed-primary"
                      (click)="showShareModal = true"
                    >
                      {{ downloadResource['Share'] }}
                      <i class="btn-icon ifc-custom ifc-envelope"></i>
                    </button>
                  </div>
                  <a
                    *ngIf="
                      !model.UserHasSubscription &&
                      model.PaymentType === paymentTypes.Credits
                    "
                    [href]="subscriptionsUrl"
                    >{{ paymentResource['BuySubscriptionNow'] }}</a
                  >
                  <div class="ch-ggs-web-suite-payment-info">
                    <div class="text-muted">
                      <i
                        aria-hidden="true"
                        class="btn-icon ifc-custom ifc-phone mr-2"
                      ></i>
                      {{ model.CompanyPhone }}
                    </div>
                    <div class="text-muted">
                      <i
                        aria-hidden="true"
                        class="btn-icon ifc-custom ifc-envelope mr-2"
                      ></i
                      ><a
                        [href]="'mailto:' + model.CompanyEmail"
                        class="text-reset"
                      >
                        {{ model.CompanyEmail }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hazmatsuite-next-modal
          [cancelButtonLabel]="downloadResource['ButtonCancel']"
          [confirmButtonLabel]="downloadResource['ButtonShare']"
          [title]="downloadResource['Share']"
          [showModal]="showShareModal"
          (closeModal)="showShareModal = false"
          (confirm)="share()"
        >
          <form [formGroup]="shareForm">
            <div class="form-group">
              <label for="sender">{{ downloadResource['SenderName'] }}</label>
              <div>
                <input
                  class="form-control"
                  type="text"
                  id="sender"
                  formControlName="sender"
                />
              </div>
              <span
                *ngIf="sender?.invalid && (sender?.dirty || sender?.touched)"
                class="text-danger"
              >
                {{ validationResource['InputRequired'] }}
              </span>
            </div>
            <div class="form-group">
              <label for="recipient">{{ downloadResource['Recipient'] }}</label>
              <div>
                <input
                  class="form-control"
                  type="text"
                  id="recipient"
                  formControlName="recipient"
                />
              </div>
              <span
                *ngIf="
                  recipient?.invalid && (recipient?.dirty || recipient?.touched)
                "
                class="text-danger"
              >
                {{ validationResource['InputRequired'] }}
              </span>
            </div>
          </form>
        </hazmatsuite-next-modal>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
